import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { Subscription, debounceTime, tap } from 'rxjs'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ModalLegalEntitySubClientComponent } from '../../customer/modal_subclient/modal-legal-entity-subclient/modal-legal-entity-subclient.component'
import { ModalConsultantClientComponent } from '../../person/modal-consultant-client/modal-consultant-client.component'
import { ModalEmployeeConsultantComponent } from '../../employee/modal-employee-consultant/modal-employee-consultant.component'
import { ItemProposalCreateComponent } from '../item-proposal-create/item-proposal-create.component'
import { convertCurrency } from '../../../shared/utils/utils'
import moment from 'moment'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { ResponsibleService } from '../../../core/services/person/responsible/responsible.service'
import { JsonPipe } from '@angular/common'
import { AuthService } from '../../../core/services/auth/auth.service'
import { ServiceAdditionalProposalCreateComponent } from '../../service/service-additional-proposal-create/service-additional-proposal-create.component'
import { PurchasesQuoteRequestItinerariesService } from '../../../core/services/purchases/purchases-quote-request-itineraries/purchases-quote-request-itineraries.service'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'

@Component({
  selector: 'proposal-client-create',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    ItemProposalCreateComponent,
    IntegerInputDirective,
    NgxMaskDirective,
    /*  MatDivider,
    DecimalInputDirective,
    LegalEntityClientComponent,
    MatTab,
    MatTabGroup,
    ContactClientCreateComponent, */
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    JsonPipe,
    ServiceAdditionalProposalCreateComponent,
  ],
  templateUrl: './proposal-client-create.component.html',
  styleUrl: './proposal-client-create.component.scss',
  providers: [
    ProposalClientService,
    ProposalStatusService,
    PaymentMethodsService,
    PurchasesQuoteRequestItinerariesService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ProposalClientCreateComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private proposalStatusService: ProposalStatusService,
    private paymentMethodsService: PaymentMethodsService,
    private responsibleService: ResponsibleService,
    private commissionDividerService: CommissionDividerService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ProposalClientCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private purchasesQuoteRequestItinerariesService: PurchasesQuoteRequestItinerariesService,
  ) {
    this.user = this.authService.getInfosObject()
    if (data && data.user) {
      this.item = { user: true, data: data.item }
    }
  }
  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  @Output() responseEdit = new EventEmitter()

  user: any = {}
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading = false
  idClient = -1

  private autosaveSub?: Subscription
  private restoring = false
  draftStatus: 'idle' | 'saving' | 'saved' = 'idle'

  ListProposalStatus: any[] = []
  ListServiceAdditional: any[] = []
  ListPaymentMethods: any[] = []
  ListResponsible: any[] = []

  ListCommission: any[] = [
    { value: 0, description: 'tg.mob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ListItemsProposal: any[] = []

  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}

  ngOnInit(): void {
    this.getStatusProposal()
    this.getCommissionDivider()
    this.createForm()
    this.setupAutosave()
    this.checkDraft()
  }

  ngOnDestroy(): void {
    this.autosaveSub?.unsubscribe()
  }

  getStatusProposal() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListProposalStatus = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getCommissionDivider(id = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          this.fillCommission(this.commissionDividerTg)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.ListCommission[1].disabled = false
              this.form.get('typeCommission')!.setValue(1)
              this.fillCommission(this.commissionDividerClient)
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 1,
                comissao: 0,
              }
              this.fillCommission(this.commissionDividerTg)
              this.form.get('typeCommission')!.setValue(0)
              this.ListCommission[1].disabled = true
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(0))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(0))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(0))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 0) {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 1) {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
  }

  getPaymentMethod(id: number) {
    this.ListPaymentMethods = []
    this.paymentMethodsService.listPaymentMethodsByPerson(id).subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListPaymentMethods = response.data
        this.form.get('paymentMethod')!.enable()
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.form.get('paymentMethod')!.enable()
      },
    })
  }

  getResponsible(id: number) {
    // this.ListResponsible = []
    // this.responsibleService.listResponsibleByPerson(id).subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.ListResponsible = response.data
    //     this.form.get('responsible')!.enable()
    //   },
    //   error: (err: ResponseRequestModel) => {
    //     console.error(err)
    //   },
    //   complete: () => {
    //     this.form.get('responsible')!.enable()
    //   },
    // })
  }

  createProposalClient() {
    this.loading = true
    const model = this.createModel()
    this.proposalClientService.createProposalClient(model).subscribe({
      next: (response: ResponseRequestModel) => {
        const propostaId = response?.data?.id
        if (propostaId) {
          this.purchasesQuoteRequestItinerariesService
            .updateRequestPurchase(propostaId)
            .subscribe({
              next: () => {},
              error: () => {},
            })
        }
        this.snackbar.success(response.message)
        this.loading = false
        this.clearDraft()
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  checkForm() {
    // if (this.ListItemsProposal.length < 1) {
    //   return false
    // } else {
    //   return true
    // }

    if (this.form.valid && this.ListItemsProposal.length > 0) {
      return true
    } else {
      return false
    }
  }

  close() {
    // Cancelar é uma ação deliberada de abandonar: descarta o rascunho.
    // (Fechar a aba / queda do navegador não passa por aqui e mantém o rascunho.)
    this.clearDraft()
    this.dialogRef.close()
  }

  // ── Rascunho (continuar criação de onde parou) ────────────────────────────
  // Espelha o padrão de staging em localStorage usado na logística
  // (logistics-contract-item-create: `logistics_draft_${id}`). Um rascunho por
  // usuário, pois a tela cria sempre uma proposta nova por vez.

  private get draftKey(): string {
    return `proposta_draft_${this.user?.funcionarioId ?? 'anon'}`
  }

  private buildSnapshot() {
    return {
      form: this.form.getRawValue(),
      clientSelected: this.clientSelected,
      subClientSelected: this.subClientSelected,
      consultantClientSelected: this.consultantClientSelected,
      employeeConsultantSelected: this.employeeConsultantSelected,
      ListItemsProposal: this.ListItemsProposal,
      ListServiceAdditional: this.ListServiceAdditional,
      commissionDividerClient: this.commissionDividerClient,
      commissionDividerTg: this.commissionDividerTg,
      idClient: this.idClient,
    }
  }

  // Evita gravar rascunho "vazio" só por abrir a tela.
  private hasDraftableContent(): boolean {
    return !!(
      this.clientSelected?.id ||
      this.ListItemsProposal.length ||
      this.ListServiceAdditional.length ||
      this.form.get('eventName')?.value
    )
  }

  private canAutosave(): boolean {
    return !this.restoring && this.hasDraftableContent()
  }

  // Feedback visual: "Salvando..." assim que o usuário altera algo.
  private markSaving(): void {
    if (this.canAutosave()) this.draftStatus = 'saving'
  }

  saveDraft(): void {
    if (!this.canAutosave()) return
    try {
      localStorage.setItem(this.draftKey, JSON.stringify(this.buildSnapshot()))
      this.draftStatus = 'saved'
    } catch (e) {
      console.error('Falha ao salvar rascunho da proposta', e)
    }
  }

  private getDraft(): any | null {
    const raw = localStorage.getItem(this.draftKey)
    return raw ? JSON.parse(raw) : null
  }

  private clearDraft(): void {
    localStorage.removeItem(this.draftKey)
  }

  private setupAutosave(): void {
    this.autosaveSub = this.form.valueChanges
      .pipe(
        tap(() => this.markSaving()),
        debounceTime(500),
      )
      .subscribe(() => this.saveDraft())
  }

  private checkDraft(): void {
    const draft = this.getDraft()
    if (!draft) return

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      disableClose: true,
      data: {
        title: 'Proposta não finalizada',
        message:
          'Encontramos uma proposta que você começou e não finalizou. Deseja recuperar o progresso e continuar de onde parou?',
        confirmLabel: 'Recuperar',
      },
    })
    dialogRef.afterClosed().subscribe((recover: boolean) => {
      if (recover) {
        this.restoreDraft(draft)
      } else {
        this.clearDraft()
      }
    })
  }

  private restoreDraft(draft: any): void {
    this.restoring = true

    // Datas: viram string ISO ao serializar para JSON; o datepicker espera Date.
    const formValue = { ...(draft.form ?? {}) }
    if (formValue.dateStart) formValue.dateStart = new Date(formValue.dateStart)
    if (formValue.dateEnd) formValue.dateEnd = new Date(formValue.dateEnd)
    this.form.patchValue(formValue)

    this.clientSelected = draft.clientSelected ?? {}
    this.subClientSelected = draft.subClientSelected ?? {}
    this.consultantClientSelected = draft.consultantClientSelected ?? {}
    this.employeeConsultantSelected = draft.employeeConsultantSelected ?? {}
    this.commissionDividerClient = draft.commissionDividerClient ?? this.commissionDividerClient
    this.commissionDividerTg = draft.commissionDividerTg ?? this.commissionDividerTg
    this.idClient = draft.idClient ?? -1
    this.ListItemsProposal = draft.ListItemsProposal ?? []
    this.ListServiceAdditional = draft.ListServiceAdditional ?? []

    // Reabilita os campos dependentes do cliente e repopula opções vindas de API.
    if (this.clientSelected?.id) {
      this.form.get('subClient')!.enable()
      this.form.get('consultant')!.enable()
      const pessoaId =
        this.subClientSelected?.pessoaId ?? this.clientSelected?.pessoaId
      if (pessoaId) {
        // Mantém a forma de pagamento salva enquanto as opções recarregam.
        const savedPaymentMethod = this.form.get('paymentMethod')?.value
        this.getPaymentMethod(pessoaId)
        this.form.get('paymentMethod')!.setValue(savedPaymentMethod)
      }
    }

    this.updateGrandTotal()
    this.restoring = false
  }

  createModel() {
    return {
      propostaCliente: {
        clienteId: this.clientSelected.id,
        subClienteId: this.subClientSelected.id ?? 0,
        consultorId: this.consultantClientSelected.consultorId ?? 0,
        nomeEvento: this.form.get('eventName')?.value ?? '',
        formaPagamentoId: this.form.get('paymentMethod')?.value ?? '',
        consultorComercialId: this.employeeConsultantSelected.id ?? 0,
        dataInicio: moment(this.form.get('dateStart')!.value).format(
          'DD/MM/YYYY',
        ),
        // horaInicio: this.form.get('timeStart')!.value,
        dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
        // horaFim: this.form.get('timeEnd')!.value,
        quantidadePassageiros:
          parseInt(
            String(this.form.get('numPassengers')?.value ?? '').replace(
              /\D/g,
              '',
            ),
            10,
          ) || 0,
        solicitante: this.form.get('requesterName')?.value ?? '',
        solicitanteEmail: this.form.get('requesterEmail')?.value ?? '',
        solicitanteTelefone: this.form.get('requesterPhone')?.value ?? '',
        // tipoComissao: this.form.get('typeCommission')?.value ?? '',
        // comissao: this.form.get('commission')?.value ?? '',
        // taxa: this.form.get('tax')?.value ?? '',
        // divisor: this.form.get('divider')?.value ?? '',
      },
      itens: this.getItemsProposal(),
      servicosAdicionais: this.getItemsAdditional(),
    }
  }

  getItemsAdditional() {
    const list: any[] = []
    for (let index = 0; index < this.ListServiceAdditional.length; index++) {
      const element = this.ListServiceAdditional[index]
      list.push({
        servicoAdicionalId: element.serviceAdditionalId,
        dataServico: element.date_formatted,
        quantidade: element.amount,
        taxa: parseFloat(element.tax),
        valorUnitario: parseFloat(element.priceUnit),
        valorTotal: parseFloat(element.priceTotal),
      })
    }

    return list
  }

  getItemsProposal() {
    const items = []
    for (let index = 0; index < this.ListItemsProposal.length; index++) {
      const element = this.ListItemsProposal[index]
      const itineraries = []
      // Envia SEMPRE as paradas P do próprio item (com endereço completo),
      // inclusive para itens com tarifário — espelha o fluxo de proposta
      // existente (item-proposal-include-form), que persiste o que o usuário
      // digitou. Origem/destino seguem sendo enviados abaixo.
      //
      // ATENÇÃO (deploy casado): exige que o backend PARE de auto-copiar o
      // template do tarifário em PropostaCliente/create. Enquanto a auto-cópia
      // existir, estas paradas serão DUPLICADAS (cópia "magra" cidade/estado do
      // template + as completas enviadas aqui). Ver relatório de backend.
      const paradasItem = (element.intinerarios ?? []).filter(
        (it: any) => (it?.trecho ?? 'P') === 'P',
      )
      for (
        let indexItineraries = 0;
        indexItineraries < paradasItem.length;
        indexItineraries++
      ) {
        const elementItineraries = paradasItem[indexItineraries]
        itineraries.push({
          localParada: elementItineraries.descricao,
          descricao: '',
          cep: elementItineraries.cep,
          logradouro: elementItineraries.logradouro,
          numero: elementItineraries.numero,
          bairro: elementItineraries.bairro,
          latitude:
            elementItineraries.latitude != ''
              ? elementItineraries.latitude
              : null,
          longitude:
            elementItineraries.longitude != ''
              ? elementItineraries.longitude
              : null,
          cidade: elementItineraries.cidade,
          estado: elementItineraries.estado,
          complemento: elementItineraries.complemento,
          trecho: elementItineraries.trecho,
          areaTarifario: elementItineraries.areaTarifario,
        })
      }

      if (
        // element.origin.cep != '' &&
        // element.origin.logradouro != '' &&
        // element.origin.numero != '' &&
        // element.origin.bairro != '' &&
        element.origin.cidade != '' &&
        element.origin.estado != ''
      ) {
        itineraries.push({
          // localParada: 'Origem',
          localParada: element.origin.descricao,
          cep: element.origin.cep,
          logradouro: element.origin.logradouro,
          numero: element.origin.numero,
          bairro: element.origin.bairro,
          latitude:
            element.origin.latitude != '' ? element.origin.latitude : null,
          longitude:
            element.origin.longitude != '' ? element.origin.longitude : null,
          cidade: element.origin.cidade,
          estado: element.origin.estado,
          complemento: element.origin.complemento,
          trecho: 'O',
          areaTarifario: 'S',
          descricao: element.origin.cidade,
          // descricao: element.origin.descricao,
        })
      }

      if (
        // element.destination.cep != '' &&
        // element.destination.logradouro != '' &&
        // element.destination.numero != '' &&
        // element.destination.bairro != '' &&
        element.destination.cidade != '' &&
        element.destination.estado != ''
      ) {
        itineraries.push({
          // localParada: 'Destino',
          localParada: element.destination.descricao,
          cep: element.destination.cep,
          logradouro: element.destination.logradouro,
          numero: element.destination.numero,
          bairro: element.destination.bairro,
          latitude:
            element.destination.latitude != ''
              ? element.destination.latitude
              : null,
          longitude:
            element.destination.longitude != ''
              ? element.destination.longitude
              : null,
          cidade: element.destination.cidade,
          estado: element.destination.estado,
          complemento: element.destination.complemento,
          trecho: 'D',
          areaTarifario: 'S',
          descricao: element.destination.cidade,
          // descricao: element.destination.descricao,
        })
      }

      items.push({
        tarifarioId:
          element.tarifarioId && element.tarifarioId != ''
            ? element.tarifarioId
            : null,
        origemId: element.origemId,
        destinoId: element.destinoId,
        tipoServicoId: element.tipoServicoId,
        servicoId: element.servicoId,
        tipoVeiculoId: element.tipoVeiculoId,
        tipoMotoristaId: element.tipoMotoristaId,

        tipoTarifarioId: element.tipoTarifarioId,

        quantidadePassageiros: element.numPessoas,
        quantidadeVeiculos: element.numVeiculos,

        valorUnitario:
          typeof element.vendaUnitario != 'number'
            ? convertCurrency(element.vendaUnitario)
            : element.vendaUnitario,
        valorVenda:
          typeof element.vendaSemTaxa != 'number'
            ? convertCurrency(element.vendaSemTaxa)
            : element.vendaSemTaxa,
        valorComTaxa:
          typeof element.venda != 'number'
            ? convertCurrency(element.venda)
            : element.venda,
        valorTaxa:
          typeof element.valorTaxa != 'number'
            ? convertCurrency(element.valorTaxa)
            : element.valorTaxa,
        valorKmVenda:
          typeof element.saleKmExtra != 'number'
            ? convertCurrency(element.saleKmExtra)
            : element.saleKmExtra,
        valorHoraVenda:
          typeof element.saleHoraExtra != 'number'
            ? convertCurrency(element.saleHoraExtra)
            : element.saleHoraExtra,

        isPermuta: element.isPermuta ? 'S' : 'N',
        isComissiona: element.isCortesia ? 'S' : 'N',
        isCortesia: element.isCortesia ? 'S' : 'N',

        dataInicio: element.dataInicioFormatada,
        horaInicio: element.horaInicio == '' ? '' : element.horaInicio + ':00',

        dataFinal: element.dataFinalFormatada,
        horaFinal: element.horaFinal == '' ? '' : element.horaFinal + ':00',

        tipoDivisor: element.tipoComissao,
        taxa:
          typeof element.taxa != 'number'
            ? convertCurrency(element.taxa)
            : element.taxa,
        divisor:
          typeof element.divisor != 'number'
            ? convertCurrency(element.divisor)
            : element.divisor,
        comissao:
          typeof element.comissao != 'number'
            ? convertCurrency(element.comissao)
            : element.comissao,

        itinerarios: itineraries,
        observacao: element.observacao,
      })
    }

    return items
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusProposal: [2],
      eventName: ['', [Validators.required]],
      dateStart: ['', [Validators.required]],
      // timeStart: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      // timeEnd: ['', [Validators.required]],
      client: ['', [Validators.required]],
      subClient: [''],
      consultant: ['', [Validators.required]],
      employeeConsultant: [''],
      serviceFee: [convertCurrency(0)],
      // serviceFee: [convertCurrency(0), [Validators.required]],
      grandTotal: [convertCurrency(0), [Validators.required]],
      numPassengers: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      requesterName: ['', [Validators.required]],
      requesterEmail: ['', [Validators.required]],
      requesterPhone: ['', [Validators.required]],
      typeCommission: [0],
      // commission: ['', [Validators.required]],
      // divider: ['', [Validators.required]],
      // tax: ['', [Validators.required]],
      commission: [''],
      divider: [''],
      tax: [''],
      // responsible: [''],
    })
    this.form.get('statusProposal')!.disable()
    this.form.get('subClient')!.disable()
    this.form.get('consultant')!.disable()
    this.form.get('grandTotal')!.disable()
    this.form.get('paymentMethod')!.disable()
    // this.form.get('responsible')!.disable()

    if (this.user.funcionarioFuncaoId && this.user.funcionarioFuncaoId == 4) {
      this.employeeConsultantSelected = {
        id: this.user.funcionarioId,
        nome: this.user.name,
      }
      this.form.get('employeeConsultant')!.setValue(this.user.name)
    }
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
        create: true,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection
            this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
            this.clearItem([
              'subClient',
              'consultant',
              'paymentMethod',
              'responsable',
            ])
            this.form.get('subClient')!.enable()
            this.form.get('consultant')!.enable()
            this.getPaymentMethod(this.clientSelected.pessoaId)
            this.getResponsible(this.clientSelected.pessoaId)
            this.idClient = this.clientSelected.id
            this.getCommissionDivider(this.clientSelected.id)
          }
        } else {
          this.clearItem([
            'client',
            'subClient',
            'consultant',
            'paymentMethod',
            'responsable',
          ])
          this.form.get('subClient')!.disable()
          this.form.get('consultant')!.disable()
          this.form.get('paymentMethod')!.disable()
          // this.form.get('responsible')!.disable()
          this.idClient = -1
          this.commissionDividerClient = {
            taxa: 0,
            divisor: 0,
            comissao: 0,
          }
          this.fillCommission(this.commissionDividerTg)
          this.form.get('typeCommission')!.setValue(0)
          this.ListCommission[1].disabled = true
        }
      }
    })
  }

  addSubClient() {
    const dialogRef = this.dialog.open(ModalLegalEntitySubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: this.clientSelected.id,
        clientInfo: this.clientSelected,
        item: this.subClientSelected,
        multiSelect: false,
        create: true,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.subClientSelected.id) {
            this.subClientSelected = response.selection
            this.form
              .get('subClient')!
              .setValue(this.subClientSelected.nomeFantasia)
            this.clearItem(['consultant', 'paymentMethod', 'responsible'])
            this.getPaymentMethod(this.subClientSelected.pessoaId)
            this.getResponsible(this.subClientSelected.pessoaId)
            this.idClient = this.subClientSelected.id
            this.getCommissionDivider(this.subClientSelected.id)
          }
        } else {
          this.clearItem([
            'subClient',
            'consultant',
            'paymentMethod',
            'responsible',
          ])
          this.getPaymentMethod(this.clientSelected.id)
          this.getResponsible(this.clientSelected.id)
          this.idClient = this.clientSelected.id
          this.getCommissionDivider(this.clientSelected.id)
        }
      }
    })
  }

  addConsultantClient() {
    const idClient =
      this.subClientSelected && this.subClientSelected.id
        ? this.subClientSelected.id
        : this.clientSelected.id
    const dialogRef = this.dialog.open(ModalConsultantClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: idClient,
        item: {
          id: this.consultantClientSelected.consultorId,
          description: this.consultantClientSelected,
        },
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (
            response.selection.consultorId !=
            this.consultantClientSelected.consultorId
          ) {
            this.consultantClientSelected = response.selection
            this.form
              .get('consultant')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterName')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterEmail')!
              .setValue(this.consultantClientSelected.email)
            this.form
              .get('requesterPhone')!
              .setValue(this.consultantClientSelected.telefone)
          }
        } else {
          this.clearItem(['consultant'])
        }
      }
    })
  }

  addEmployeeConsultant() {
    const dialogRef = this.dialog.open(ModalEmployeeConsultantComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.employeeConsultantSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.form
            .get('employeeConsultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearItem(['employeeConsultant'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
    if (items.includes('responsible')) {
      // this.ListResponsible = []
      // this.form.get('responsible')!.setValue('')
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  getList(list: any[]) {
    this.ListItemsProposal = list
    this.updateGrandTotal()
    this.checkItensProposal()
    this.saveDraft()
  }

  getListServiceAdditional(list: any[]) {
    this.ListServiceAdditional = list
    this.updateGrandTotal()
    this.saveDraft()
  }

  checkItensProposal() {
  }

  updateGrandTotal() {
    let totalSale = 0
    for (let index = 0; index < this.ListItemsProposal.length; index++) {
      const element = this.ListItemsProposal[index]
      if (typeof element.venda == 'string') {
        // @ts-ignore
        totalSale = totalSale + convertCurrency(element.venda)
      } else if (typeof element.venda == 'number') {
        totalSale = totalSale + element.venda
      }
    }
    for (let index = 0; index < this.ListServiceAdditional.length; index++) {
      const element = this.ListServiceAdditional[index]
      if (typeof element.priceTotal == 'string') {
        // @ts-ignore
        totalSale = totalSale + convertCurrency(element.priceTotal)
      } else if (typeof element.priceTotal == 'number') {
        totalSale = totalSale + element.priceTotal
      }
    }

    // this.ListItemsProposal.reduce(
    //   (total, ele) => total + convertCurrency(ele.venda),
    //   0,
    // )

    totalSale = Math.ceil(!isFinite(totalSale) ? 0 : (totalSale ?? 0))

    this.form.get('grandTotal')!.setValue(convertCurrency(totalSale))
  }

  fillResponsible() {
    // if (this.form.get('responsible')!.value != '') {
    //   let responsible = this.form.get('responsible')!.value
    //
    //   this.form.get('requesterName')!.setValue(responsible.nome ?? '')
    //   this.form.get('requesterPhone')!.setValue(responsible.telefone ?? '')
    //   this.form.get('requesterEmail')!.setValue(responsible.email ?? '')
    //
    //   this.form.get('responsible')!.setValue('')
    // }
  }

  getPeriod() {
    return {
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      dataInicioDescription: this.form.get('dateStart')!.value,
      dataFimDescription: this.form.get('dateEnd')!.value,
    }
  }
}
